<template>
  <b-container fluid>
    <b-row class="mx-0">
      <b-col class="px-0">
        <b-row style="border-bottom: 1px solid #000;" class="my-auto">
          <b-col class="my-auto" cols="5">
            <b-row>
              <b-col cols="2">ลำดับ</b-col>
              <b-col cols="8">ชื่อผลตรวจ</b-col>
              <b-col cols="2">ชื่อย่อ</b-col>
            </b-row>
          </b-col>
          <b-col style="border-left: 1px solid #000;" cols="7">
            <b-row style="border-bottom: 1px solid #000;">
              <b-col>
                <b-col cols="12">ราคา</b-col>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">Canine/Feline</b-col>
              <b-col cols="5">Exotic Mammals</b-col>
              <b-col cols="3">Live Stock</b-col>
            </b-row>
          </b-col>
        </b-row>
        <draggable v-model="tests">
          <transition-group>
            <div
              v-for="(test, index) in tests"
              :key="test.id"
              :class="{
                'test': true,

              }"
              @click="$emit('select', test)"
            >
              <b-row>
                <b-col cols="1">{{ index + 1 }}</b-col>
                <b-col cols="3">{{ test.name }}</b-col>
                <b-col cols="1">{{ test.abbreviation }}</b-col>
                <b-col cols="2">
                  <div
                    class="text-right"
                  >{{ test.prices.find(price => price.price_group_id === 2) ? test.prices.find(price => price.price_group_id === 2).price : '-' }}</div>
                </b-col>
                <b-col cols="3">
                  <div
                    class="text-right"
                  >{{ test.prices.find(price => price.price_group_id === 3) ? test.prices.find(price => price.price_group_id === 3).price : '-' }}</div>
                </b-col>
                <b-col cols="2">
                  <div
                    class="text-right"
                  >{{ test.prices.find(price => price.price_group_id === 4) ? test.prices.find(price => price.price_group_id === 4).price : '-' }}</div>
                </b-col>
              </b-row>
            </div>
          </transition-group>
        </draggable>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "Test",
  components: {
    draggable,
  },
  props: {
    value: {
      // test lists
      type: Array,
      default: () => [],
    },
    tabSelected: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    tests: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.test {
  padding: 1rem;
  cursor: pointer;
  text-align: left;
  &:hover {
    background: #dde9ee;
    transition: all 130ms ease-out;
  }

  &.active {
    background: #fb822b;
    color: white;
    transition: all 130ms ease-out;
  }
}
</style>